import { render, staticRenderFns } from "./ModerationTemplates.vue?vue&type=template&id=f8bfcb90&"
import script from "./ModerationTemplates.vue?vue&type=script&lang=ts&"
export * from "./ModerationTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports